import React, { Component } from 'react';
import { FaGithub, FaTwitter, FaEnvelope, FaCopyright } from "react-icons/fa";
import { ReactComponent as Logo } from '../img/logo.svg'

import '../styles/footer.scss';

class Footer extends Component {
  getTime() {
    var d = new Date();
    return d.getFullYear();
  }

  render() {
    return (
      <div className="footer">
        <section id="footer">
          <div id="footer-container">
            <div className="nav-wrapper">
                  <a href="#topper" className="logo">
                    <div id="ar-logo">
                      <Logo />
                    </div>
                  </a>
            </div>

            <div className="icons">
              <a aria-label="Github" href="https://github.com/andyroberson">
                <FaGithub />
              </a>
              <a aria-label="Twitter" href="https://twitter.com/andyroberson22">
                <FaTwitter />
              </a>
              <a aria-label="Email" href="mailto:andyroberson2@gmail.com">
                <FaEnvelope />
              </a>
            </div>


             <div className="copyright">
               Andrea Roberson <div className="copyright-icon"><FaCopyright /></div> {this.getTime()}
             </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Footer;
